<!-- Loading State -->
@if (isProcessing) {
  <mat-card class="stat-card panel-container loading-panel">
    <div class="loading-state">
      <div class="loading-header">
        <div class="jen-zen-small-wrapper">
          <div class="pulsing-circle-small"></div>
          <app-jen-zen-img [imgType]="JenZenImgType.HAPPY"></app-jen-zen-img>
        </div>
        <div class="loading-text">
          <h3>{{ currentStatusMessage }}</h3>
          <div class="progress-bar-container">
            <div class="progress-bar indeterminate">
              <div class="progress-fill-indeterminate"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="shimmer-content">
        <div class="shimmer-line" style="width: 40%;"></div>
        <div class="shimmer-line" style="width: 80%;"></div>
        <div class="shimmer-line" style="width: 60%;"></div>
      </div>
    </div>
  </mat-card>
}

<!-- Empty State -->
@if (!isProcessing && (!profile.companyName && !isEditing)) {
  <mat-card class="stat-card panel-container">
    <div class="empty-state">
      <div class="empty-content">
        <div class="empty-icon">
          <i class="material-symbols-rounded">account_balance</i>
        </div>
        <p>No customer information detected.</p>
      </div>
      <button (click)="isEditing = true" class="add-btn">
        Add Details
      </button>
    </div>
  </mat-card>
}

<!-- Main Panel -->
@if (!isProcessing && (profile.companyName || isEditing)) {
  <mat-card class="stat-card panel-container">
    <div class="panel-header">
      <div class="header-title">
        <div class="title-icon">
          <i class="material-symbols-rounded">account_balance</i>
        </div>
        <h3>Customer Information</h3>
      </div>
      <div class="header-actions">
        @if (isEditing) {
          <button (click)="cancelEdit()" class="btn-cancel-text">Cancel</button>
          <button (click)="handleSave()" class="btn-save">
            <i class="material-symbols-rounded">check_circle</i> Save
          </button>
        } @else {
          <button (click)="isEditing = true" class="btn-edit">
            <i class="material-symbols-rounded">edit</i>
          </button>
        }
      </div>
    </div>
    <div class="panel-body">
      <!-- Company & Address -->
      <div class="form-section">
        <div>
          <label class="field-label">Company Name</label>
          @if (isEditing) {
            <div>
              <app-smart-input
                [value]="formData.companyName"
                (valueChange)="handleChange('companyName', $event)"
                matchingType="entity"
                [linkedId]="linkedCompanyId"
                (linkMatch)="handleLinkCompany($event)"
                placeholder="Company Name"
              ></app-smart-input>
            </div>
          } @else {
            <div class="display-value">{{ formData.companyName }}</div>
          }
        </div>
        <div>
          <label class="field-label with-icon">
            <i class="material-symbols-rounded">place</i> Billing Address
          </label>
          @if (isEditing) {
            <div>
              <div class="address-grid">
                <div style="grid-column: span 2;">
                  <app-smart-input
                    [value]="formData.billingAddressStreet1"
                    (valueChange)="handleChange('billingAddressStreet1', $event)"
                    placeholder="Street Address"
                    matchingType="address"
                    (linkMatch)="handleLinkAddress($event)"
                  ></app-smart-input>
                </div>
                <input
                  [ngModel]="formData.billingAddressCity"
                  (ngModelChange)="handleChange('billingAddressCity', $event)"
                  placeholder="City"
                  class="form-input"
                  />
                <div class="address-row">
                  <input
                    [ngModel]="formData.billingAddressState"
                    (ngModelChange)="handleChange('billingAddressState', $event)"
                    placeholder="State"
                    class="form-input narrow"
                    />
                  <input
                    [ngModel]="formData.billingAddressZip"
                    (ngModelChange)="handleChange('billingAddressZip', $event)"
                    placeholder="Zip"
                    class="form-input"
                    />
                </div>
              </div>
            </div>
          } @else {
            <div class="display-value secondary">
              {{ formData.billingAddressStreet1 }}<br/>
              {{ formData.billingAddressCity }}@if (formData.billingAddressCity) {
              <span>, </span>
              }{{ formData.billingAddressState }} {{ formData.billingAddressZip }}
            </div>
          }
        </div>
      </div>
      <!-- Contact Info -->
      <div class="form-section">
        <div class="contact-header">Primary Contact (Optional)</div>
        <div class="contact-grid">
          <div>
            <label class="contact-label">First Name</label>
            @if (isEditing) {
              <div>
                <input
                  [ngModel]="formData.contactFirstName"
                  (ngModelChange)="handleChange('contactFirstName', $event)"
                  class="form-input small"
                  />
              </div>
            } @else {
              <div class="contact-value">{{ formData.contactFirstName || '-' }}</div>
            }
          </div>
          <div>
            <label class="contact-label">Last Name</label>
            @if (isEditing) {
              <div>
                <input
                  [ngModel]="formData.contactLastName"
                  (ngModelChange)="handleChange('contactLastName', $event)"
                  class="form-input small"
                  />
              </div>
            } @else {
              <div class="contact-value">{{ formData.contactLastName || '-' }}</div>
            }
          </div>
        </div>
        <div class="contact-grid">
          <div>
            <label class="contact-label">Email</label>
            @if (isEditing) {
              <div>
                <input
                  [ngModel]="formData.contactEmail"
                  (ngModelChange)="handleChange('contactEmail', $event)"
                  class="form-input small"
                  />
              </div>
            } @else {
              <div class="contact-value truncate" [title]="formData.contactEmail">{{ formData.contactEmail || '-' }}</div>
            }
          </div>
          <div>
            <label class="contact-label">Phone</label>
            @if (isEditing) {
              <div>
                <input
                  [ngModel]="formData.contactPhone"
                  (ngModelChange)="handleChange('contactPhone', $event)"
                  class="form-input small"
                  />
              </div>
            } @else {
              <div class="contact-value">{{ formData.contactPhone || '-' }}</div>
            }
          </div>
        </div>
      </div>
    </div>
  </mat-card>
}
